import { all, call, getContext, put, takeEvery } from 'redux-saga/effects';
import type { IUserInfo } from '../../api/domain';
import type { SecurityApiService } from '../../api/services';
import { logError } from '../logging-api/logging-api-actions';
import { fetchUserInfo, fetchUserInfoFailure, fetchUserInfoSuccess } from './user-info-api-actions';

function* handleFetchUserInfo() {
    const api: SecurityApiService = yield getContext('userInfoApiService');

    try {
        const userInfo: IUserInfo = yield call([api, api.fetchUserInfo]);
        yield put(fetchUserInfoSuccess(userInfo));
    } catch (error: unknown) {
        yield put(logError(`could not fetch user-info: ${error}`));
        yield put(fetchUserInfoFailure());
    }
}

export function* userInfoApiSaga() {
    yield all([takeEvery(fetchUserInfo, handleFetchUserInfo)]);
}
